package com.crowpay.extensions

import com.crowpay.ReadByDataModel
import com.crowpay.HasReadBy
import com.crowpay.sdk.ReadByModelCache
import com.lightningkite.UUID
import com.lightningkite.kiteui.reactive.ReactiveContext
import com.lightningkite.kiteui.reactive.onRemove
import com.lightningkite.lightningdb.HasId
import com.lightningkite.lightningserver.db.CachingModelRestEndpoints
import kotlinx.coroutines.CoroutineScope
import kotlin.jvm.JvmName

fun HasReadBy.isUnread(id: UUID): Boolean = id !in readBy

fun Collection<HasReadBy>.isUnread(id: UUID): Boolean = any { item -> id !in item.readBy }

fun Collection<HasReadBy>.readByIntersection(): Set<UUID> =
    if (isEmpty()) emptySet()
    else map { it.readBy }.reduce { acc, readBy -> acc.intersect(readBy) }

@JvmName("setIdsIsUnread")
fun Set<UUID>?.isUnread(id: UUID): Boolean =
    this == null || !this.contains(id)

fun Set<UUID>.isUnread(id: UUID): Boolean = id !in this

/**Marks the items as read, but only locally updates when the scope is closed*/
suspend fun <T : ReadByDataModel> ReadByModelCache<T>.markAsReadUpdateOnRemove(scope: CoroutineScope, items: Collection<T>) {
    markAsReadDelayUpdate(items)?.let(scope::onRemove)
}

suspend fun <T : ReadByDataModel> ReadByModelCache<T>.markAsRead(item: T) = markAsRead(listOf(item))
fun <T : ReadByDataModel> ReadByModelCache<T>.handleOne(item: ReactiveContext.(ReadByModelCache<T>) -> T) = handle { listOf(item(it)) }
